export default __webpack_public_path__ + "static/media/consulter-garanties.e7c6e77d.jpg";